import { apolloClient } from '@/plugins/apollo';
import { Comment } from '@/models';
import {
  CreateComment,
  UpdateComment,
  DeleteComment,
} from '@/graphql';

const actions = {
  async create(context, { referenceId, text }) {
    const response = await apolloClient.mutate({
      mutation: CreateComment,
      variables: {
        comment: {
          reference: referenceId,
          text,
        },
      },
      update(cache, { data: { createComment } }) {
        const referenceRef = cache.identify({
          __typename: 'Reference',
          id: createComment.reference.id,
        });
        cache.modify({
          id: referenceRef,
          fields: {
            comments(existingComments, { toReference, readField }) {
              const alreadyExists = !!existingComments.find(
                (commentRef) =>
                  readField('id', commentRef) === createComment.id
              );
              return alreadyExists
                ? existingComments
                : [...existingComments, toReference(createComment)];
            },
          },
        });
      },
    });

    return new Comment(response.data.createComment);
  },
  async update(context, { commentId, text }) {
    const response = await apolloClient.mutate({
      mutation: UpdateComment,
      variables: {
        comment: {
          id: commentId,
          text,
        },
      },
    });

    return new Comment(response.data.updateComment);
  },
  async delete(context, { id, referenceId }) {
    await apolloClient.mutate({
      mutation: DeleteComment,
      variables: { id },
      update(cache) {
        const referenceRef = cache.identify({
          __typename: 'Reference',
          id: referenceId,
        });
        cache.modify({
          id: referenceRef,
          fields: {
            comments(existingComments, { readField }) {
              return existingComments.filter(
                (commentRef) => readField('id', commentRef) !== id
              );
            },
          },
        });
      },
    });
  },
};

const state = {};

export default {
  namespaced: true,
  actions,
  state,
};
